<template>
  <div class="section_footer">
    <b-container>
      <b-row>
        <b-col class="d-none d-md-block" md="6" lg="6" xl="6">
          <img v-if="language == 'ru'" src="../assets/map_footer_ru.png">
          <img v-else src="../assets/map_footer_en.png">
        </b-col>
        <b-col cols="12" sm="12" md="6" lg="4" xl="4" offset-xl="2" offset-lg="2">
          <b-row>
            <!-- <b-col sm="12" md="12" lg="12" xl="12"><div class="H2">{{title[language]}}</div></b-col> -->
            <b-col class="name" sm="12" md="12" lg="12" xl="12">{{name[language]}}</b-col>
            <b-col class="phone" sm="12" md="12" lg="12" xl="12">
              <a href="tel:+78312660230"><span>8 (831)</span> 266-02-30</a>
            </b-col>
            <b-col class="mail" sm="12" md="12" lg="12" xl="12">
              <a href="mailto:info@raduga-nn.com">info@raduga-nn.com</a>
            </b-col>
            <b-col class="addres" sm="12" md="12" lg="12" xl="12">{{addres[language]}}</b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'AppFooter',
  props: {
    language: {
      type: String,
      default: 'ru'
    }
  },
  data() {
    return {
      title: {
        ru: 'Наши контакты',
        en: 'Сontact'
      },
      name: {
        ru: 'ООО "Радуга НН"',
        en: '"RADUGA-NN" LLC'
      },
      addres: {
        ru: '603033, Россия, г. Нижний Новгород, ул. Героя Овчинникова 1А, оф. 49.',
        en: 'Russia, Nizhny Novgorod, ul. Geroya Ovchinnikova,1А, of. 49'
      },
    };
  }
}
</script>

<style lang="scss">
@media (min-width: 768px) and (max-width: 991px) {
  .section_footer .name{margin-top: 0!important;}
}
@media (min-width: 576px) and (max-width: 767px) {
  .section_footer .name{margin-top: 0!important;}
}
@media (max-width: 575px) {
  .section_footer .name{margin-top: 0!important;}
}
  .section_footer{
    background: #464646;
    padding: 20px 0;
    color: #fff;
    font-size: 20px
  }
  .section_footer a{color: #fff;line-height: 26px}
  .section_footer .H2{color: #fff;text-align: left}
  .section_footer  img {
    margin-top: 10px;
    max-width: 100%;
    height: auto;
  }
  .section_footer .name{font-weight: bold;font-size: 32px;line-height: 38px;font-family: 'Open Sans Condensed', sans-serif;margin-top: 30px;}
  .section_footer .addres{font-size: 16px;}
</style>


// WEBPACK FOOTER //
// src/views/Footer.vue